import * as z from 'zod';
import { TFunction } from 'i18next';

const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\w\-._~:/?#[\]@!$&'()*+,;=/]*)?$/;

export const getOrganizationFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t('validity.valueMissing.defaultMessage')).max(100),
    abbreviation: z.string().min(1, t('validity.valueMissing.defaultMessage')).max(40),
    type: z.string().min(1, t('validity.valueMissing.defaultMessage')),
    countryId: z.number().optional(),
    website: z
      .string()
      .max(255)
      .optional()
      .or(z.literal(''))
      .refine((value) => !value || value === '' || websiteRegex.test(value), t('org.website.error.message')),
    wingsId: z.string().max(40).optional().or(z.literal('')),
    isDonor: z.boolean(),
    isClearingAgent: z.boolean()
  });

export type OrganizationFormData = z.infer<ReturnType<typeof getOrganizationFormSchema>>;
